module.exports = __webpack_public_path__ + "static/media/diary.515e93ce.jpg";